export enum JOB_STATUSES {
    CREATED = 0,
    READY = 10,
    PENDING = 12,
    SCHEDULED = 16,
    PROCESSING = 20,
    CANCELING = 24,
    CANCELED = 30,
    DEADLINE_EXCEEDED = 34,
    FAILED = 40,
    SUCCESS = 50,
}

export const jobEndFailureStatuses: ReadonlyArray<JOB_STATUSES> = [
    JOB_STATUSES.CANCELED,
    JOB_STATUSES.DEADLINE_EXCEEDED,
    JOB_STATUSES.FAILED,
];

export const jobEndSuccessStatuses: ReadonlyArray<JOB_STATUSES> = [JOB_STATUSES.SUCCESS];

export const jobEndStatuses: ReadonlyArray<JOB_STATUSES> = [...jobEndFailureStatuses, ...jobEndSuccessStatuses];

export const JOB_POLL_INTERVAL = 2500; // 2.5 sec
